/**
 * If a value is an array, return it. Otherwise, return it as the first element in an array.
 */
export function arrayify<T>(value: T | T[]): T extends Array<any> ? T : T[] {
  if (Array.isArray(value)) return value as any;
  return [value] as any;
}
